import React from 'react';
import { styled, CommonStyles, Shape, Body, Caption } from '@teko/ds-foundation';
import { ForwardOutlined } from '@teko/ds-icon';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ListContentWrapper = styled.div((props) => {
  var _a, _b, _c, _d, _e, _f, _g;
  return [
    CommonStyles,
    `
  background-color: ${(_a = props.theme) == null ? void 0 : _a.colors.white};
  ${props.padding ? `padding: ${props.padding}` : `padding: ${(_b = props.theme) == null ? void 0 : _b.spacing.s12} ${(_c = props.theme) == null ? void 0 : _c.spacing.s16}`};
  display: flex;
  align-items: center;
  position: relative;
 ${props.hasDivider ? ` &:after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: ${(_d = props.theme) == null ? void 0 : _d.spacing.s16};
      bottom: 0;
      left: ${(_e = props.theme) == null ? void 0 : _e.spacing.s16};
      border-bottom: ${(_f = props.theme) == null ? void 0 : _f.borderWeight.m} solid ${(_g = props.theme) == null ? void 0 : _g.colors.divider};
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }` : ``}
`
  ];
});
const LeftContent = styled.div`
  flex: 1;
`;
const RightContent = styled.div(({ theme }) => `
  text-align: right;
  margin-left: ${theme == null ? void 0 : theme.spacing.s12};
`);
const FocusText = styled.span(({ theme }) => {
  return `
    color: ${theme == null ? void 0 : theme.colors.primary500};
  `;
});
const ListContent = React.forwardRef((_a, ref) => {
  var _b = _a, {
    label,
    subText,
    subTextFocus,
    icon,
    extra,
    rightText,
    arrow,
    hasDivider = false,
    onClick
  } = _b, rest = __objRest(_b, [
    "label",
    "subText",
    "subTextFocus",
    "icon",
    "extra",
    "rightText",
    "arrow",
    "hasDivider",
    "onClick"
  ]);
  var _a2, _b2;
  const renderSubtext = () => {
    if (!subText && !subTextFocus)
      return null;
    return /* @__PURE__ */ React.createElement(Caption, {
      color: "textSecondary",
      level: 1,
      line: 1
    }, subText && /* @__PURE__ */ React.createElement("span", null, subText), subTextFocus && /* @__PURE__ */ React.createElement(FocusText, null, " ", subTextFocus));
  };
  return /* @__PURE__ */ React.createElement(ListContentWrapper, __spreadValues({
    onClick: () => {
      if (onClick)
        onClick();
    },
    hasDivider,
    ref
  }, rest), icon && /* @__PURE__ */ React.createElement(Shape, {
    marginRight: "s12"
  }, React.cloneElement(icon, {
    size: !((_a2 = icon == null ? void 0 : icon.props) == null ? void 0 : _a2.size) ? 24 : (_b2 = icon == null ? void 0 : icon.props) == null ? void 0 : _b2.size
  })), /* @__PURE__ */ React.createElement(LeftContent, null, /* @__PURE__ */ React.createElement(Body, {
    level: 1,
    line: 1
  }, label), renderSubtext()), /* @__PURE__ */ React.createElement(RightContent, null, rightText && !extra && /* @__PURE__ */ React.createElement(Body, {
    color: "textSecondary",
    level: 1,
    line: 1
  }, rightText), extra), arrow && !extra && /* @__PURE__ */ React.createElement(Shape, {
    marginLeft: "s8"
  }, /* @__PURE__ */ React.createElement(ForwardOutlined, {
    size: 20
  })));
});
ListContent.displayName = "ListContent";

export { ListContent };
